import { compose, withHandlers } from 'recompose';

import ContactCard from 'components/ContactsList/ContactCard/styled';

const enhance = compose(
  withHandlers({
    handleStartOrderWithAddress:
      ({ onClickStartWithAddress, contact }) =>
      () => {
        onClickStartWithAddress(contact);
      },
  })
);

export default enhance(ContactCard);
